module.exports = __webpack_public_path__ + "images/mobile/icon-doc-folder-0fac77e34feea3140be62356fa95b08d.png";